import { Button } from '@fp/ui-kit'
import type { ToastAction } from '@lib/emitToast'

export function ToastActions({ actions }: { actions?: ToastAction[] }) {
  if (!actions?.length) return null

  return (
    <div className='mt-2 flex flex-wrap gap-2'>
      {actions.map(({ label, href }) => (
        <Button key={href} asChild variant='outline' size='sm'>
          <a href={href} target='_blank' rel='noopener noreferrer'>
            {label}
          </a>
        </Button>
      ))}
    </div>
  )
}
